/**
 * Display helpers for employer transaction lists (aligned with Android employer transaction UI).
 */

const AVATAR_HUES = ['#FF9800', '#4CAF50', '#5716D7', '#2196F3', '#E91E63', '#009688'];

export function avatarColorForName(name) {
  const s = String(name || 'G');
  let hash = 0;
  for (let i = 0; i < s.length; i += 1) {
    hash = s.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_HUES[Math.abs(hash) % AVATAR_HUES.length];
}

export function initialLetter(name) {
  const s = String(name || 'G').trim();
  if (!s) return 'G';
  return s.charAt(0).toUpperCase();
}

/** Mask phone for privacy, e.g. +91 999** ****67 */
export function maskPhone(phone) {
  if (!phone || typeof phone !== 'string') return '';
  const digits = phone.replace(/\D/g, '');
  if (digits.length < 10) return '••••••••••';
  const last10 = digits.slice(-10);
  return `+91 ${last10.slice(0, 3)}** ****${last10.slice(-2)}`;
}

export function transactionDisplayName(tip) {
  const customer = tip.customerName?.trim();
  if (customer) return customer;
  if (tip.customerPhone) return 'Guest';
  const emp = tip.employeeName?.trim();
  if (emp && emp !== 'Unknown') return emp;
  return 'Guest';
}

export function formatInr(amount) {
  const n = Number(amount || 0);
  return `₹${n.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}

/** Tip line items: leading plus, two decimals (matches Android list). */
export function formatTipCredit(amount) {
  const n = Number(amount || 0);
  return `+₹${n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
